<template>
  <div class="f-socialWallPage">
    <div class="title-container">
      <h1>{{activeLanguage.contest}}
        <br/>
        "Alpine Food Heritage Stories"</h1>
    </div>

    <b-row class="buttons-wrapper">
      <div class="regulation-box">
        <h5 v-html="activeLanguage.regulationsItems[1].title"></h5>
        <p v-html="activeLanguage.regulationsItems[1].content"></p>
        <h5 v-html="activeLanguage.regulationsItems[2].title"></h5>
        <p v-html="activeLanguage.regulationsItems[2].content"></p>
      </div>
      <b-col>
        <button :class="[ iconWrapper]"
                @click="openRegulationsModal()">
          <p class="activeLabel" style="padding: 0">
            <span class="iconc icon-rules"></span>
            {{activeLanguage.regulations}}
          </p>
        </button>
      </b-col>
      <b-col v-if="activeLanguage.winnersList && activeLanguage.winnersList.length > 0">
        <button :class="[ iconWrapper]"
                @click="openWinnersModal()">
          <p class="activeLabel" style="padding: 0"><span class="iconc icon-winner"></span>{{activeLanguage.winners}}
          </p>
        </button>
      </b-col>
      <regulations-modal ref="regulationsModal"></regulations-modal>
      <winners-modal ref="winnersModal"></winners-modal>
    </b-row>
    <template v-if="new Date() >= new Date('4/23/2019 13:00:00')">
      <div v-if="new Date() >= new Date('6/16/2019 23:55:00')">
        <p class="loading-subtitle">{{activeLanguage.contestClosing}}</p>
      </div>
      <div infinite-scroll-disabled="busy" infinite-scroll-distance="30" v-infinite-scroll="fetchTweetsOnLoadMore">
        <transition mode="out-in" name="fade">
          <div key="1" v-if="isLoadingContent">
            <p class="loading-subtitle">{{activeLanguage.contentLoading}}</p>
            <grid-loader :loading="isLoadingContent" color="#c41c21" size="40px" style="width: 100%"></grid-loader>
          </div>

          <div key="2" v-else-if="isEmptyContent">
            <p class="loading-subtitle">{{activeLanguage.contentEmpty}}</p>
            <div class="empty-box"></div>
            <p class="loading-subtitle" style="margin-top: 10px">{{activeLanguage.contestEnding}}</p>
          </div>

          <div key="3" v-else>
<!--            <p class="loading-subtitle" style="margin-top: 10px">{{activeLanguage.contestEnding}}</p>-->
            <!--<div class="wrapper">-->
            <!--<div class="masonry-container-new">-->
            <!--<social-card :key="index" :post-content="post" class="brick"-->
            <!--v-for="(post, index) in posts" v-on:update-image="handleOutDatedPost"/>-->
            <!--</div>-->
            <!--</div>-->
            <div :class="getContainerClass" :fit-width="true" item-selector=".item" transition-duration="0.3s"
                 v-masonry>
              <div :key="index" class="item" v-for="(post, index) in posts" v-masonry-tile>
                <social-card :post-content="post" v-on:update-image="handleOutDatedPost"/>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </template>
    <template v-else>
      <div>
        <p class="loading-subtitle">{{activeLanguage.contestOpening}}</p>
        <div class="contest-photo"></div>
      </div>
    </template>
  </div>
</template>

<script>
  import SocialCard from '../../utilComponents/SocialCard'
  import Vue from 'vue'
  import GridLoader from 'vue-spinner/src/GridLoader.vue'
  import {VueMasonryPlugin} from 'vue-masonry'
  import RegulationsModal from './RegulationsModal'
  import WinnersModal from './WinnersModal'

  Vue.use(VueMasonryPlugin)

  export default {
    name: 'ContestPage',
    components: {WinnersModal, RegulationsModal, SocialCard, GridLoader},
    data () {
      return {
        posts: [],
        socialFilter: {'Twitter': false, 'Instagram': true},
        userFilter: {'AlpFoodway': true, 'Others': true},
        isLoadingState: true,
        areInformationOutdated: false,
        profilesToUpdate: [],
        iconWrapper: 'icon-wrapper',
        isSmallWindow: false
      }
    },
    props: {
      default: {
        type: Object
      }
    },
    methods: {
      openRegulationsModal () {
        this.$refs.regulationsModal.showModal()
      },
      openWinnersModal () {
        this.$refs.winnersModal.showModal()
      },
      fetchTweetsOnLoad () {
        let self = this
        this.$http.get(this.$PATH_NAME + 'contest/get20' + this.getRequestValue).then((response) => {
          if (response.status === 200) {
            self.posts = response.body
            // setInterval(function () {
            //   self.pollNewPosts()
            // }, 3000)
          }
        }).catch(function (err) {
          this.handleError(err)
        }).finally(function () {
          this.isLoadingState = false
        })
      },
      // pollNewPosts () {
      //   let self = this
      //   let lastId = this.posts[0].id_str
      //   this.$http.get(this.$PATH_NAME + 'contest/pollNew&fromId=' + lastId + this.getRequestValue).then((response) => {
      //     if (response.status === 200) {
      //       response.body.forEach((post) => {
      //         self.posts.push(post)
      //       })
      //     }
      //   }).catch(function (err) {
      //     this.handleError(err)
      //   })
      // },
      fetchTweetsOnLoadMore () {
        let self = this
        if (this.posts[this.posts.length - 1]) {
          let lastId = this.posts[this.posts.length - 1].id_str
          this.$http.get(this.$PATH_NAME + 'contest/get20&fromId=' + lastId + this.getRequestValue).then((response) => {
            response.body.forEach((post) => {
              self.posts.push(post)
            })
          }
          ).catch(function (err) {
            this.handleError(err)
          })
        }
      },
      postIsShown (post) {
        return this.socialFilter[post.type]
      },
      handleOutDatedPost (userScreenName) {
        this.areInformationOutdated = true
        if (!this.profilesToUpdate) {
          this.profilesToUpdate = []
        }
        if (!this.profilesToUpdate.includes(userScreenName)) {
          this.profilesToUpdate.push(userScreenName)
          this.updateOutDatedPost(userScreenName)
        }
      },
      updateOutDatedPost (userScreenName) {
        let self = this
        this.$http.get(this.$PATH_NAME + '/social/updateProfileInformation/profile=' + userScreenName).then((response) => {
          self.posts.forEach(post => {
            if (post.user.screenName === userScreenName) {
              post.user.profileImageUrl = response.body
            }
          })
        }
        ).catch(function (err) {
          this.handleError(err)
        })
      },
      handleError (err) {
        if (err.status >= 500) {
          console.log('Server-Related problem')
        } else if (err.status === 400) {
          console.log('A bad request occurred')
        } else if (err.status === 404) {
          console.log(err.body.message)
        }
      },
      checkWindowSize () {
        if ((!this.isSmallWindow) && window.innerWidth < 1051) {
          this.isSmallWindow = true
        } else if (this.isSmallWindow && window.innerWidth > 1051) {
          this.isSmallWindow = false
        }
      }
    },
    mounted () {
      this.$store.commit('setCurrentView', this.default)
      this.fetchTweetsOnLoad()
      this.checkWindowSize()
      window.addEventListener('resize', () => this.checkWindowSize())
    },
    computed: {
      activeLanguage () {
        let currLang = this.$translations[this.$store.getters.currentLanguageValue]
        if (currLang.regulationsItems) {
          return this.$translations[this.$store.getters.currentLanguageValue]
        } else {
          return this.$translations['Italian']
        }
      },
      isLoadingContent () {
        return this.isLoadingState
      },
      isEmptyContent () {
        return this.posts.length === 0 && !this.isLoadingState
      },
      getRequestValue () {
        return '/Twitter=' + this.socialFilter['Twitter'] + '&Instagram=' + this.socialFilter['Instagram'] + '/AlpFoodway=' + this.userFilter['AlpFoodway'] + '&OtherPosts=' + this.userFilter['Others'] + '/'
      },
      isAlpfoodwayDisabled () {
        return !this.userFilter['AlpFoodway']
      },
      getContainerClass () {
        return this.isSmallWindow ? 'post-container-mobile' : 'post-container'
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style scoped>

  .loading-subtitle {
    font-size: 3vh;
    font-weight: bold;
    color: #888;
  }

  .twitter-disabled {
    width: 1.25em;
    background-image: url("data:image/svg+xml;utf8;base64,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");
  }

  .twitter-enabled {
    width: 1.25em;
    background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNjRweCIgaGVpZ2h0PSI2NHB4Ij4KPGc+Cgk8Zz4KCQk8cGF0aCBkPSJNNTEyLDk3LjI0OGMtMTkuMDQsOC4zNTItMzkuMzI4LDEzLjg4OC02MC40OCwxNi41NzZjMjEuNzYtMTIuOTkyLDM4LjM2OC0zMy40MDgsNDYuMTc2LTU4LjAxNiAgICBjLTIwLjI4OCwxMi4wOTYtNDIuNjg4LDIwLjY0LTY2LjU2LDI1LjQwOEM0MTEuODcyLDYwLjcwNCwzODQuNDE2LDQ4LDM1NC40NjQsNDhjLTU4LjExMiwwLTEwNC44OTYsNDcuMTY4LTEwNC44OTYsMTA0Ljk5MiAgICBjMCw4LjMyLDAuNzA0LDE2LjMyLDIuNDMyLDIzLjkzNmMtODcuMjY0LTQuMjU2LTE2NC40OC00Ni4wOC0yMTYuMzUyLTEwOS43OTJjLTkuMDU2LDE1LjcxMi0xNC4zNjgsMzMuNjk2LTE0LjM2OCw1My4wNTYgICAgYzAsMzYuMzUyLDE4LjcyLDY4LjU3Niw0Ni42MjQsODcuMjMyYy0xNi44NjQtMC4zMi0zMy40MDgtNS4yMTYtNDcuNDI0LTEyLjkyOGMwLDAuMzIsMCwwLjczNiwwLDEuMTUyICAgIGMwLDUxLjAwOCwzNi4zODQsOTMuMzc2LDg0LjA5NiwxMDMuMTM2Yy04LjU0NCwyLjMzNi0xNy44NTYsMy40NTYtMjcuNTIsMy40NTZjLTYuNzIsMC0xMy41MDQtMC4zODQtMTkuODcyLTEuNzkyICAgIGMxMy42LDQxLjU2OCw1Mi4xOTIsNzIuMTI4LDk4LjA4LDczLjEyYy0zNS43MTIsMjcuOTM2LTgxLjA1Niw0NC43NjgtMTMwLjE0NCw0NC43NjhjLTguNjA4LDAtMTYuODY0LTAuMzg0LTI1LjEyLTEuNDQgICAgQzQ2LjQ5Niw0NDYuODgsMTAxLjYsNDY0LDE2MS4wMjQsNDY0YzE5My4xNTIsMCwyOTguNzUyLTE2MCwyOTguNzUyLTI5OC42ODhjMC00LjY0LTAuMTYtOS4xMi0wLjM4NC0xMy41NjggICAgQzQ4MC4yMjQsMTM2Ljk2LDQ5Ny43MjgsMTE4LjQ5Niw1MTIsOTcuMjQ4eiIgZmlsbD0iIzAwYWNlZCIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=");
  }

  .instagram-enabled {
    width: 1.25em;
    background-image: url("data:image/svg+xml;utf8;base64,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");
  }

  .facebook-enabled {
    width: 1.25em;
    background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij4KPHBhdGggc3R5bGU9ImZpbGw6IzRENkZBOTsiIGQ9Ik00NzYuNjksNTEySDM1LjMxQzE1Ljg5LDUxMiwwLDQ5Ni4xMSwwLDQ3Ni42OVYzNS4zMUMwLDE1Ljg5LDE1Ljg5LDAsMzUuMzEsMEg0NzYuNjkgIEM0OTYuMTEsMCw1MTIsMTUuODksNTEyLDM1LjMxVjQ3Ni42OUM1MTIsNDk2LjExLDQ5Ni4xMSw1MTIsNDc2LjY5LDUxMiIvPgo8cGF0aCBzdHlsZT0iZmlsbDojRkZGRkZGOyIgZD0iTTQzMi41NTIsODguMjc2djg4LjI3NmgtNzkuNDQ4Yy05LjcxLDAtMTcuNjU1LDcuOTQ1LTE3LjY1NSwxNy42NTV2NTIuOTY2aDg4LjI3NnY4OC4yNzZoLTg4LjI3NiAgVjUxMmgtODguMjc2VjMzNS40NDhoLTcwLjYyMXYtODguMjc2aDcwLjYyMXYtNTIuOTY2YzAtNTUuNjE0LDQyLjM3Mi0xMDEuNTE3LDk3LjEwMy0xMDUuOTMxSDQzMi41NTJ6Ii8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=");
  }

  .instagram-disabled {
    width: 1.25em;
    background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNjRweCIgaGVpZ2h0PSI2NHB4Ij4KPGc+Cgk8Zz4KCQk8cGF0aCBkPSJNMzUyLDBIMTYwQzcxLjY0OCwwLDAsNzEuNjQ4LDAsMTYwdjE5MmMwLDg4LjM1Miw3MS42NDgsMTYwLDE2MCwxNjBoMTkyYzg4LjM1MiwwLDE2MC03MS42NDgsMTYwLTE2MFYxNjAgICAgQzUxMiw3MS42NDgsNDQwLjM1MiwwLDM1MiwweiBNNDY0LDM1MmMwLDYxLjc2LTUwLjI0LDExMi0xMTIsMTEySDE2MGMtNjEuNzYsMC0xMTItNTAuMjQtMTEyLTExMlYxNjBDNDgsOTguMjQsOTguMjQsNDgsMTYwLDQ4ICAgIGgxOTJjNjEuNzYsMCwxMTIsNTAuMjQsMTEyLDExMlYzNTJ6IiBmaWxsPSIjY2Q0ODZiIi8+Cgk8L2c+CjwvZz4KPGc+Cgk8Zz4KCQk8cGF0aCBkPSJNMjU2LDEyOGMtNzAuNjg4LDAtMTI4LDU3LjMxMi0xMjgsMTI4czU3LjMxMiwxMjgsMTI4LDEyOHMxMjgtNTcuMzEyLDEyOC0xMjhTMzI2LjY4OCwxMjgsMjU2LDEyOHogTTI1NiwzMzYgICAgYy00NC4wOTYsMC04MC0zNS45MDQtODAtODBjMC00NC4xMjgsMzUuOTA0LTgwLDgwLTgwczgwLDM1Ljg3Miw4MCw4MEMzMzYsMzAwLjA5NiwzMDAuMDk2LDMzNiwyNTYsMzM2eiIgZmlsbD0iI2NkNDg2YiIvPgoJPC9nPgo8L2c+CjxnPgoJPGc+CgkJPGNpcmNsZSBjeD0iMzkzLjYiIGN5PSIxMTguNCIgcj0iMTcuMDU2IiBmaWxsPSIjY2Q0ODZiIi8+Cgk8L2c+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==");
  }

  .facebook-disabled {
    width: 1.25em;
    background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjY0cHgiIGhlaWdodD0iNjRweCI+CjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPgoJPGc+CgkJPHBhdGggZD0iTTQ2OC4zMzMtMUg0MS42NjdDMTcuNzczLTEtMSwxNy43NzMtMSw0MS42Njd2NDI2LjY2N0MtMSw0OTIuMjI3LDE3Ljc3Myw1MTEsNDEuNjY3LDUxMWgxOTYuMjY3aDEwMi40aDEyOCAgICBDNDkyLjIyNyw1MTEsNTExLDQ5Mi4yMjcsNTExLDQ2OC4zMzNWNDEuNjY3QzUxMSwxNy43NzMsNDkyLjIyNy0xLDQ2OC4zMzMtMXogTTI1NSw0OTMuOTMzVjMyMy4yNjdoLTY4LjI2N1YyNTVIMjU1di01OS43MzMgICAgYzAtNDguNjQsMzcuNTQ3LTg5LjYsODUuMzMzLTkzLjg2N2g3Ni44djY4LjI2N2gtNjguMjY3Yy0xNC41MDcsMC0yNS42LDExLjA5My0yNS42LDI1LjZWMjU1SDQwOC42djY4LjI2N2gtODUuMzMzdjE3MC42NjdIMjU1eiAgICAgTTQ5My45MzMsNDY4LjMzM2MwLDE0LjUwNy0xMS4wOTMsMjUuNi0yNS42LDI1LjZoLTEyOHYtMTUzLjZoODUuMzMzdi0xMDIuNGgtODUuMzMzdi00Mi42NjdjMC01LjEyLDMuNDEzLTguNTMzLDguNTMzLTguNTMzICAgIEg0MzQuMnYtMTAyLjRoLTk0LjcyYy01Ny4xNzMsNS4xMi0xMDEuNTQ3LDUzLjc2LTEwMS41NDcsMTEwLjkzM3Y0Mi42NjdoLTY4LjI2N3YxMDIuNGg2OC4yNjd2MTUzLjZINDEuNjY3ICAgIGMtMTQuNTA3LDAtMjUuNi0xMS4wOTMtMjUuNi0yNS42VjQxLjY2N2MwLTE0LjUwNywxMS4wOTMtMjUuNiwyNS42LTI1LjZoNDI2LjY2N2MxNC41MDcsMCwyNS42LDExLjA5MywyNS42LDI1LjZWNDY4LjMzM3oiIGZpbGw9IiMzYjU5OTgiLz4KCTwvZz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K");
  }

  .iconc {
    display: inline-block;
    height: 1.25em;
    background-repeat: no-repeat;
    background-size: contain;
    vertical-align: text-bottom;
  }

  .buttons-wrapper {
    padding-left: 15%;
    padding-right: 15%;
    margin: 0 auto 2%;
  }

  .checkbox-disabled {
    width: 1.25em;
    background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDQ0IDQ0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA0NCA0NCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCI+CiAgPHBhdGggZD0ibTIyLDBjLTEyLjIsMC0yMiw5LjgtMjIsMjJzOS44LDIyIDIyLDIyIDIyLTkuOCAyMi0yMi05LjgtMjItMjItMjJ6bTMuMiwyMi40bDcuNSw3LjVjMC4yLDAuMiAwLjMsMC41IDAuMywwLjdzLTAuMSwwLjUtMC4zLDAuN2wtMS40LDEuNGMtMC4yLDAuMi0wLjUsMC4zLTAuNywwLjMtMC4zLDAtMC41LTAuMS0wLjctMC4zbC03LjUtNy41Yy0wLjItMC4yLTAuNS0wLjItMC43LDBsLTcuNSw3LjVjLTAuMiwwLjItMC41LDAuMy0wLjcsMC4zLTAuMywwLTAuNS0wLjEtMC43LTAuM2wtMS40LTEuNGMtMC4yLTAuMi0wLjMtMC41LTAuMy0wLjdzMC4xLTAuNSAwLjMtMC43bDcuNS03LjVjMC4yLTAuMiAwLjItMC41IDAtMC43bC03LjUtNy41Yy0wLjItMC4yLTAuMy0wLjUtMC4zLTAuN3MwLjEtMC41IDAuMy0wLjdsMS40LTEuNGMwLjItMC4yIDAuNS0wLjMgMC43LTAuM3MwLjUsMC4xIDAuNywwLjNsNy41LDcuNWMwLjIsMC4yIDAuNSwwLjIgMC43LDBsNy41LTcuNWMwLjItMC4yIDAuNS0wLjMgMC43LTAuMyAwLjMsMCAwLjUsMC4xIDAuNywwLjNsMS40LDEuNGMwLjIsMC4yIDAuMywwLjUgMC4zLDAuN3MtMC4xLDAuNS0wLjMsMC43bC03LjUsNy41Yy0wLjIsMC4xLTAuMiwwLjUgMy41NTI3MWUtMTUsMC43eiIgZmlsbD0iIzAwMDAwMCIvPgo8L3N2Zz4K");
  }

  .checkbox-enabled {
    width: 1.25em;
    background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDQ0IDQ0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA0NCA0NCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCI+CiAgPHBhdGggZD0ibTIyLDBjLTEyLjIsMC0yMiw5LjgtMjIsMjJzOS44LDIyIDIyLDIyIDIyLTkuOCAyMi0yMi05LjgtMjItMjItMjJ6bTEyLjcsMTUuMWwwLDAtMTYsMTYuNmMtMC4yLDAuMi0wLjQsMC4zLTAuNywwLjMtMC4zLDAtMC42LTAuMS0wLjctMC4zbC03LjgtOC40LS4yLS4yYy0wLjItMC4yLTAuMy0wLjUtMC4zLTAuN3MwLjEtMC41IDAuMy0wLjdsMS40LTEuNGMwLjQtMC40IDEtMC40IDEuNCwwbC4xLC4xIDUuNSw1LjljMC4yLDAuMiAwLjUsMC4yIDAuNywwbDEzLjQtMTMuOWgwLjFjMC40LTAuNCAxLTAuNCAxLjQsMGwxLjQsMS40YzAuNCwwLjMgMC40LDAuOSAwLDEuM3oiIGZpbGw9IiNjNDFjMjEiLz4KPC9zdmc+Cg==");
  }

  .icon-wrapper {
    border: 3px solid #eee;;
    border-radius: 15px;
    width: 100%;
    height: 55px;
    cursor: pointer;
    background-color: white;
  }

  .icon-wrapper:focus {
    outline: none;
    /*box-shadow: 0 0 1pt 1pt red;*/
  }

  .inline-label {
    display: -webkit-inline-box;
  }

  .inline-label > p {
    margin-left: 15%;
    padding: 0 20% 0 0;
  }

  .disabled {
    opacity: 0.3;
  }

  .activeLabel {
    font-weight: bold;
    color: #c41c21 !important;
  }

  .disabledLabel {
    font-weight: bold;
    color: black;
  }

  .post-container {
    margin: 0 auto;
  }


  .post-container-mobile {
    width: 100% !important;
  }

  .icon-rules {
    width: 1.25em;
    background-image: url("https://i.imgur.com/uMVpzXD.png");
  }

  .icon-winner {
    width: 1.25em;
    background-image: url("https://i.imgur.com/5TkwFXA.png");
  }

  .icon {
    display: inline-block;
    height: 1.25em;
    background-repeat: no-repeat;
    background-size: contain;
    vertical-align: text-bottom;
  }

  /*---------------------------------------------------------------*/
  /* Masonry grid */
  .masonry-container-new {
    transition: all .5s ease-in-out;
    column-gap: 0;
    column-fill: initial;
  }

  /* Masonry item */
  .masonry-container-new .brick {
    margin-bottom: 0;
    display: inline-block; /* Fix the misalignment of items */
    vertical-align: top; /* Keep the item on the very top */
  }

  /* Masonry image effects */
  .masonry-container-new .brick img {
    transition: all .5s ease-in-out;
    backface-visibility: hidden; /* Remove Image flickering on hover */
  }

  .masonry-container-new .brick:hover img {
    opacity: .75;
  }

  /* Masonry on tablets */
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    .masonry-container-new {
      column-count: 2;
    }
  }

  /* Masonry on big screens */
  @media only screen and (min-width: 1024px) {
    .desc {
      font-size: 1.25em;
    }

    .intro {
      letter-spacing: 1px;
    }

    .masonry-container-new {
      column-count: 4;
    }
  }

  .wrapper {
    margin-left: auto;
    margin-right: auto;
    /*padding-right: 1.5em;*/
    /*padding-left: 1.5em;*/
    max-width: 85%;
  }

  .regulation-box {
    text-align: left;
  }

  h5 {
    text-align: left;
    color: #c41c21;
  }

  /*-----------------------------------------------------------------------*/
</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/contestPageComponents/ContestPage.vue